import { Input, Select, SelectItem } from "@heroui/react";
import { FilterCard } from "@/components/data-table";

/**
 * Filter component for Purchase Order page
 *
 * @param {Object} filterOptions - Options for select filters (passed from parent)
 *   - suppliers: Array of { value, title }
 *   - statuses: Array of { value, title }
 *   - paymentMethods: Array of { value, title }
 */
const FilterData = ({ table, initialFilters, filterOptions = {} }) => {
    const { filterPanel } = table;
    const { isOpen, pending, setPending, apply, clear } = filterPanel;

    const {
        suppliers = [],
        statuses = [],
        paymentMethods = [],
    } = filterOptions;

    // Handle clear - reset to initial values
    const handleClear = () => {
        setPending(initialFilters);
        clear();
    };

    return (
        <FilterCard isVisible={isOpen} onClear={handleClear} onApply={apply}>
            {/* No. Order */}
            <Input
                label="No. Order"
                placeholder="Cari nomor order..."
                value={pending.order_number || ""}
                onValueChange={(val) =>
                    setPending((prev) => ({
                        ...prev,
                        order_number: val,
                    }))
                }
                variant="flat"
                isClearable
            />

            {/* Supplier */}
            <Select
                label="Supplier"
                placeholder="Pilih supplier"
                selectedKeys={
                    pending.supplier_id ? [String(pending.supplier_id)] : []
                }
                onSelectionChange={(keys) =>
                    setPending((prev) => ({
                        ...prev,
                        supplier_id: Array.from(keys)[0] || "",
                    }))
                }
                variant="flat"
            >
                {suppliers.map((s) => (
                    <SelectItem key={String(s.value)} value={s.value}>
                        {s.title}
                    </SelectItem>
                ))}
            </Select>

            {/* Status */}
            <Select
                label="Status"
                placeholder="Pilih status"
                selectionMode="multiple"
                selectedKeys={
                    new Set(
                        Array.isArray(pending.status_id)
                            ? pending.status_id.map(String)
                            : [],
                    )
                }
                onSelectionChange={(keys) =>
                    setPending((prev) => ({
                        ...prev,
                        status_id: Array.from(keys),
                    }))
                }
                variant="flat"
            >
                {statuses.map((s) => (
                    <SelectItem key={String(s.value)} value={s.value}>
                        {s.title}
                    </SelectItem>
                ))}
            </Select>

            {/* Metode Bayar */}
            <Select
                label="Metode Bayar"
                placeholder="Pilih metode"
                selectionMode="multiple"
                selectedKeys={
                    new Set(
                        Array.isArray(pending.payment_method_id)
                            ? pending.payment_method_id.map(String)
                            : [],
                    )
                }
                onSelectionChange={(keys) =>
                    setPending((prev) => ({
                        ...prev,
                        payment_method_id: Array.from(keys),
                    }))
                }
                variant="flat"
            >
                {paymentMethods.map((p) => (
                    <SelectItem key={String(p.value)} value={p.value}>
                        {p.title}
                    </SelectItem>
                ))}
            </Select>

            {/* Dari Tanggal */}
            <Input
                type="date"
                label="Dari Tanggal"
                value={pending.date_from || ""}
                onValueChange={(val) =>
                    setPending((prev) => ({
                        ...prev,
                        date_from: val,
                    }))
                }
                variant="flat"
            />

            {/* Sampai Tanggal */}
            <Input
                type="date"
                label="Sampai Tanggal"
                value={pending.date_to || ""}
                onValueChange={(val) =>
                    setPending((prev) => ({
                        ...prev,
                        date_to: val,
                    }))
                }
                variant="flat"
            />
        </FilterCard>
    );
};

export default FilterData;
